import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import SrBox from 'client/components/SrBox';
import SrCard from 'client/components/SrCard/SrCard';
import SrDarkModal from 'client/components/SrDarkModal';
import SrS3FileDisplay from 'client/components/SrS3FileDisplay';
import SrInitialsCircle, {
  SR_INITIALS_CIRCLE_THEME_PURPLE,
  SR_INITIALS_CIRCLE_THEME_YELLOW,
} from 'client/components/SrInitialsCircle/SrInitialsCircle';
import SrButton, { SR_BUTTON_THEME_ADOBE_BLUE } from 'client/components/SrButton/SrButton';

import './SrModalDocsSplitView.less';

function getInitialState(groups) {
  const item = ((groups[0] || {}).items || [])[0] || null;
  if (!item) {
    return null;
  }
  return {
    title: `${groups[0].title}: ${item.title} ${item.subtitle || ''}`.trim(),
    value: item.value,
  };
}

const SrModalDocsSplitView = ({
  navbarTitle,
  sidebarTitle,
  hideGroupTitles,
  ctaText,
  ctaClick,
  groups,
  onClose,
}) => {
  const [viewingItem, setViewingItem] = useState(getInitialState(groups));

  return (
    <SrDarkModal>
      <SrBox styleName="SrModalDocsSplitView">
        <SrBox styleName="navbar">
          <img
            onClick={onClose}
            src="/images/x-circle-gray-dark.svg"
            alt="close-icon"
            styleName="closeButton"
            width="40px"
            height="40px"
          />
          {navbarTitle}
        </SrBox>
        <SrBox styleName="body">
          <SrBox styleName="leftChildContainer">
            <SrBox styleName="leftChildInner">
              <SrBox styleName="sidebarItemContainer">
                <SrBox styleName="sidebarTitle">{sidebarTitle}</SrBox>
                {groups.map((group, index) => (
                  <SrCard
                    // eslint-disable-next-line react/no-array-index-key
                    key={`${group.title}-${index}`}
                    margin={index === 0 ? '0 0 10px' : '10px 0'}
                    padding="15px"
                  >
                    {group.title && !hideGroupTitles && (
                      <SrBox styleName="sidebarGroupTitle">
                        <SrBox display="inlineBlock" paddingRight="10px">
                          <SrInitialsCircle
                            name={group.title}
                            theme={
                              index % 2 === 0
                                ? SR_INITIALS_CIRCLE_THEME_PURPLE
                                : SR_INITIALS_CIRCLE_THEME_YELLOW
                            }
                          />
                        </SrBox>
                        {group.title}
                      </SrBox>
                    )}
                    {(group.items || []).map(({ title, subtitle, value }, index) => {
                      const isActive = viewingItem?.value === value;
                      return (
                        <SrBox
                          // eslint-disable-next-line react/no-array-index-key
                          key={`${value}-${index}`}
                          styleName={classnames('itemRow', isActive && 'itemRowActive')}
                          onClick={() => {
                            setViewingItem({
                              title: `${group.title}: ${title} ${subtitle || ''}`.trim(),
                              value: value,
                            });
                          }}
                        >
                          <SrBox>
                            <span styleName="sidebarItemTitle">{title}</span>
                            {subtitle && <span styleName="sidebarItemSubtitle">{subtitle}</span>}
                          </SrBox>
                          <SrBox styleName="sidebarItemViewCta">
                            {isActive ? 'viewing' : 'View'}
                          </SrBox>
                        </SrBox>
                      );
                    })}
                  </SrCard>
                ))}
              </SrBox>
              {ctaText && ctaClick && (
                <SrBox styleName="sidebarFooter">
                  <SrButton
                    theme={SR_BUTTON_THEME_ADOBE_BLUE}
                    hasBoxShadow
                    minWidth="100%"
                    onClick={ctaClick}
                  >
                    {ctaText}
                  </SrButton>
                </SrBox>
              )}
            </SrBox>
          </SrBox>
          <SrBox styleName="rightChildContainer">
            {viewingItem && (
              <>
                <SrBox styleName="fileTitle">{viewingItem.title}</SrBox>
                <SrBox styleName="fileContent">
                  <SrS3FileDisplay url={viewingItem.value} />
                </SrBox>
              </>
            )}
          </SrBox>
        </SrBox>
      </SrBox>
    </SrDarkModal>
  );
};

SrModalDocsSplitView.propTypes = {
  navbarTitle: PropTypes.string.isRequired,
  sidebarTitle: PropTypes.string.isRequired,
  groups: PropTypes.array.isRequired,
  onClose: PropTypes.func.isRequired,
  hideGroupTitles: PropTypes.bool,
  ctaText: PropTypes.string,
  ctaClick: PropTypes.func,
};

SrModalDocsSplitView.displayName = 'SrModalDocsSplitView';

export default SrModalDocsSplitView;
